import { Outlet } from 'react-router'
import { routes } from 'types/routes'
import { useTranslation } from 'react-i18next'
import { PageTab } from 'layouts/page-layout/types.ts'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import EditLayout from 'layouts/edit-layout/EditLayout'
import useGetRouteLayout from 'hooks/useGetRouteLayout.ts'
import { FaqSlugB2C } from 'types/faq.ts'
import { Layouts } from 'layouts/types'

const User = () => {
  // i18n
  const { t } = useTranslation(['user', 'common'])

  // Check layout from routing
  const { layout } = useGetRouteLayout()

  const tabs: PageTab[] = [
    { label: t(($) => $.tabTitles.personal), path: routes.USER_PERSONAL },
    { label: t(($) => $.tabTitles.payment), path: routes.USER_PAYMENT },
    { label: t(($) => $.tabTitles.contact), path: routes.USER_CONTACT },
    { label: t(($) => $.tabTitles.loginDetails), path: routes.USER_LOGIN_DETAILS }
  ]

  if (layout === Layouts.EDIT_LAYOUT) {
    return (
      <EditLayout
        title={t(($) => $.nav.user, {
          ns: 'common'
        })}
      >
        <Outlet />
      </EditLayout>
    )
  }

  if (layout === Layouts.PAGE_LAYOUT) {
    return (
      <PageLayout
        title={t(($) => $.nav.user, {
          ns: 'common'
        })}
        {...{ tabs }}
        faqCategories={{ b2c: [FaqSlugB2C.MY_DETAILS] }}
      >
        <Outlet />
      </PageLayout>
    )
  }

  return <Outlet />
}

export default User
